function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null,
/*#__PURE__*/
React.createElement("style", null, ".a{fill:none;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-592.5 -904.5)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M610.074,911.057h-2.131v-1.475a5.082,5.082,0,0,0-10.164,0v1.475h-2.131A1.149,1.149,0,0,0,594.5,912.2v11.147a1.149,1.149,0,0,0,1.148,1.148h14.426a1.149,1.149,0,0,0,1.148-1.148V912.2A1.149,1.149,0,0,0,610.074,911.057Zm-11.311-1.475a4.1,4.1,0,0,1,8.2,0v1.475h-8.2Zm11.475,13.77a.166.166,0,0,1-.164.164H595.648a.166.166,0,0,1-.164-.164V912.2a.166.166,0,0,1,.164-.164h14.426a.166.166,0,0,1,.164.164Z"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M616.975,936.5a1.472,1.472,0,0,0-.492,2.86v2.222a.492.492,0,0,0,.984,0V939.36a1.472,1.472,0,0,0-.492-2.86Zm0,1.967a.492.492,0,1,1,.492-.492A.492.492,0,0,1,616.975,938.467Z",
  transform: "translate(-14.115 -21.508)"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  className: "a",
  width: 20,
  height: 20
});

var SvgLock = function SvgLock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 20,
      height: 20,
      viewBox: "0 0 20 20",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2, _ref3, _ref4)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgLock, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/Lock.e5414947.svg";
export { ForwardRef as ReactComponent };